import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { department, division, interaction, tenant, user, usermaster, performancemaster, benchmarkprogressmaster, userpermission } from './../models/admin';
import { quater, year } from './../models/slakpi';
import { Users, usergroup, page, userrights, userType, usergrouptype, pairText, slaNote,RedirectObj } from './../models/users';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AdminApiService {
  // Define API

  apiURL = environment.apiBase; 
  constructor(private http: HttpClient,  private _router: Router) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  private GetHttpOptions () {
     return {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.jwtToken()
          })
        }
  }

  //Request API for Autherization to all the API call
  _requestTextAPI(url: string, body: any) {

    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.jwtToken() });
    let options = { headers: headers, responseType: 'text' as 'json' };
    return this.http.post(url, body, options)
  }

  //JWT token access
  private jwtToken() {
    
    var struser = localStorage.getItem('accessinfo');
    if (struser) {
      let currentAccess = JSON.parse(struser);
      // create authorization header with jwt token           
      if (currentAccess && currentAccess.token) {         
        return currentAccess.token;
      }
    }
  }

  // Error handling 
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  //  API Department Start here---------------------------------//


  AdUserAuthenticatePingUser(objusermaster: Users) {
    return this.http.post(this.apiURL + '/api/Login/AuthenticatePingUser', objusermaster, this.GetHttpOptions());
  }


  public getDepartments(objDepartment: department) {
    return this.http.post(this.apiURL + '/api/Admin/GetDepartment', objDepartment, this.GetHttpOptions());
  }

  public addEditDepartment(objDepartment: department) {
    return this.http.post(this.apiURL + '/api/Admin/InsertUpdateDepartment', objDepartment, this.GetHttpOptions());
  }
  public deleteDepartment(objDepartment: department) {
    return this.http.post(this.apiURL + '/api/Admin/DeleteDepartment', objDepartment, this.GetHttpOptions());
  }

  

  //  API Department End here---------------------------------//

  //  API Division start here---------------------------------//
  public getDivisions(objDivision: division) {
    return this.http.post(this.apiURL + '/api/Admin/GetDivision', objDivision, this.GetHttpOptions());
  }
  public addEditDivision(objDivision: division) {
    return this.http.post(this.apiURL + '/api/Admin/InsertUpdateDivision', objDivision, this.GetHttpOptions());
  }
  public deleteDivision(objDivision: division) {
    return this.http.post(this.apiURL + '/api/Admin/DeleteDivision', objDivision, this.GetHttpOptions());
  }
  //  API Division End here---------------------------------//

  //  API Interaction start here---------------------------------//
  public getInteractions(objInteraction: interaction) {
    return this.http.post(this.apiURL + '/api/Admin/GetInteraction', objInteraction, this.GetHttpOptions());
  }
  public addEditInteraction(objInteraction: interaction) {
    return this.http.post(this.apiURL + '/api/Admin/InsertUpdateInteraction', objInteraction, this.GetHttpOptions());
  }
  public deleteInteraction(objInteraction: interaction) {
    return this.http.post(this.apiURL + '/api/Admin/DeleteInteraction', objInteraction, this.GetHttpOptions());
  }
  //  API Interaction End here---------------------------------//


  //  API Tenant start here---------------------------------//
  public getTenants(objTenant: tenant) {
    return this.http.post(this.apiURL + '/api/Admin/GetTenant', objTenant, this.GetHttpOptions());
  }
  public addEditTenant(objTenant: tenant) {
    return this.http.post(this.apiURL + '/api/Admin/InsertUpdateTenant', objTenant, this.GetHttpOptions());
  }
  public deleteTenant(objTenant: tenant) {
    return this.http.post(this.apiURL + '/api/Admin/DeleteTenant', objTenant, this.GetHttpOptions());
  }
  public addYear(objTenant: tenant) {
    return this.http.post(this.apiURL + '/api/Admin/AddYear', objTenant, this.GetHttpOptions());
  }
  public getYearMasterTenant(objTenant: year) {
    return this.http.post(this.apiURL + '/api/Admin/GetYearMasterTenant', objTenant, this.GetHttpOptions());
  }
  //  API Tenant End here---------------------------------//

  //  API usermaster start here---------------------------------//
  public getUserMasters(objusermaster: usermaster) {
    return this.http.post(this.apiURL + '/api/Admin/GetUserMaster', objusermaster, this.GetHttpOptions());
  }

  public addEditUserMaster(objusermaster: usermaster) {
    return this.http.post(this.apiURL + '/api/Admin/InsertUpdateUserMaster', objusermaster, this.GetHttpOptions());
  }
  public deleteUserMaster(objusermaster: usermaster) {
    return this.http.post(this.apiURL + '/api/Admin/DeleteUserMaster', objusermaster, this.GetHttpOptions());
  }
  public sendWelcomeEmailToUsers(objusermaster: usermaster) {
    return this.http.post(this.apiURL + '/api/Admin/SendWelcomeEmailToUsers', objusermaster, this.GetHttpOptions());
  }

  public getUserPermission(objuserpermission: userpermission) {
    return this.http.post(this.apiURL + '/api/Admin/GetUserPermission', objuserpermission, this.GetHttpOptions());
  }

  public addEditUserPermission(objuserpermission: userpermission) {
    return this.http.post(this.apiURL + '/api/Admin/InsertUpdateUserPermission', objuserpermission, this.GetHttpOptions());
  }
   //  API usermaster end here---------------------------------//

  //  API usertype start here---------------------------------//
  public getUserType(objuserType: userType) {
    return this.http.post(this.apiURL + '/api/Admin/GetUserType', objuserType, this.GetHttpOptions());
  }

  //API usertype end here-----------------------------//

  //  API usergroup start here---------------------------------//
  public getUserGroups(objusergroup: usergroup) {
    return this.http.post(this.apiURL + '/api/Admin/GetUserGroup', objusergroup, this.GetHttpOptions());
  }
  public getUserGroupType(objusergroup: usergrouptype) {
    return this.http.post(this.apiURL + '/api/Admin/GetUserGroupType', objusergroup, this.GetHttpOptions());
  }
  public addEditUserGroup(objusergroup: usergroup) {
    return this.http.post(this.apiURL + '/api/Admin/InsertUpdateUserGroup', objusergroup, this.GetHttpOptions());
  }
  public deleteUserGroup(objusergroup: usergroup) {
    return this.http.post(this.apiURL + '/api/Admin/DeleteUserGroup', objusergroup, this.GetHttpOptions());
  }

  public getPages(objpage: page) {
    return this.http.post(this.apiURL + '/api/Admin/GetPages', objpage, this.GetHttpOptions());
  }

  public getUserGroupRights(objusergroup: usergroup) {
    return this.http.post(this.apiURL + '/api/Admin/GetUserGroupRights', objusergroup, this.GetHttpOptions());
  }

  public getUserRights(objusergroup: userrights) {
    return this.http.post(this.apiURL + '/api/Admin/GetUserRights', objusergroup, this.GetHttpOptions());
  }
   //  API usergroup end here---------------------------------//


  //  API Performance Master start here---------------------------------//
  public getPerformanceMaster(objPerformanceMaster: performancemaster) {
    return this.http.post(this.apiURL + '/api/Admin/GetPerformanceMaster', objPerformanceMaster, this.GetHttpOptions());
  }
  public addEditPerformanceMaster(objPerformanceMaster: performancemaster) {
    return this.http.post(this.apiURL + '/api/Admin/InsertUpdatePerformanceMaster', objPerformanceMaster, this.GetHttpOptions());
  }
  public deletePerformanceMaster(objPerformanceMaster: performancemaster) {
    return this.http.post(this.apiURL + '/api/Admin/DeletePerformanceMaster', objPerformanceMaster, this.GetHttpOptions());
  }
  //  API API Performance Master end---------------------------------//

   
  public getUsers(objDepartment: user) {
    return this.http.post(this.apiURL + '/api/Admin/GetUser', objDepartment, this.GetHttpOptions());
  }


  //Login
  //Expert_Award Get
  AdUserAuthenticate(objusermaster: Users) {    
    return this.http.post(this.apiURL + '/api/Login/AuthenticateUser', objusermaster, this.GetHttpOptions());

  }
  forgotPassWord(obj: Users) {
    return this.http.post(this.apiURL + '/api/Login/ForgotPassWord', obj, this.GetHttpOptions());
  }
  public resetPassword(objusermaster: Users) {
    return this._requestTextAPI(this.apiURL + '/api/Login/RsetPassword', objusermaster);
  }
  public updateBMAgreement(objusermaster: Users) {
    return this._requestTextAPI(this.apiURL + '/api/Login/UpdateBenchMarckAgreement', objusermaster);
  }
  GetUserInfo_ByUserID(objusermaster: Users) {
    //GetUserInfo_ByUserID
    objusermaster.language = this.getCurrentLanguage();  
    return this.http.post(this.apiURL + '/api/Login/GetSrlist', objusermaster, this.GetHttpOptions());
  }
  CheckSR(obj: slaNote) {
    //GetUserInfo_ByUserID
    
    return this.http.post(this.apiURL + '/api/Login/GetSlaNote', obj, this.GetHttpOptions());
  }

  GetGenToken(obj: slaNote) {
    
    return this.http.post(this.apiURL + '/api/Login/GetGenToken', obj, this.GetHttpOptions());
  }
  SetLoginInfo_ByUserID(objusermaster: Users) {

    objusermaster.language = this.getCurrentLanguage();
    return this.http.post(this.apiURL + '/api/Login/SetLoginInfo_ByUserID', objusermaster, this.GetHttpOptions());
  }

  SetTokenInfo_ByUserName(objusermaster: Users) {

    objusermaster.language = this.getCurrentLanguage();
    return this.http.post(this.apiURL + '/api/Login/SetTokenInfo_ByUserName', objusermaster, this.GetHttpOptions());
  }

  callpairText(objuser: pairText) {
    return this.http.post(this.apiURL + '/api/Login/CallpairText', objuser, this.GetHttpOptions());

  }
  getCurrentLanguage() {

    //var lng = this._langService.getLang();
    //if (lng) { return lng.ISOCode; }
    //else { return 'en'; }

    return 'en'; 
  }


  //Master Drop Down List Get
  public GetContinentDD(obj: performancemaster) {
    return this.http.post(this.apiURL + '/api/Admin/GetContinentDD', obj, this.GetHttpOptions());
  }
  public GetCountryDD(obj: performancemaster) {
    return this.http.post(this.apiURL + '/api/Admin/GetCountryDD', obj, this.GetHttpOptions());
  }
  public GetRegionDD(obj: performancemaster) {
    return this.http.post(this.apiURL + '/api/Admin/GetRegionDD', obj, this.GetHttpOptions());
  }
  
  public GetSourceTypeDD(obj: performancemaster) {
    return this.http.post(this.apiURL + '/api/Admin/GetSourceTypeDD', obj, this.GetHttpOptions());
  }
  
  public GetUtilityTypeDD(obj: performancemaster) {
    return this.http.post(this.apiURL + '/api/Admin/getUtilityTypeDD', obj, this.GetHttpOptions());
  }
  
  public GetPeerTypeDD(obj: performancemaster) {
    return this.http.post(this.apiURL + '/api/Admin/GetPeerTypeDD', obj, this.GetHttpOptions());
  }
  
  //bench mark progress master
  public getBMProgressTypeDD(obj: benchmarkprogressmaster) {
    return this.http.post(this.apiURL + '/api/Admin/GetBMProgressTypeDD', obj, this.GetHttpOptions());
  }

  public addEditBMProgressMaster(obj: benchmarkprogressmaster) {
    return this.http.post(this.apiURL + '/api/Admin/InsertUpdateBMProgressMaster', obj, this.GetHttpOptions());
  }
  public getBMProgressMaster(obj: benchmarkprogressmaster) {
    return this.http.post(this.apiURL + '/api/Admin/GetBMProgressMaster', obj, this.GetHttpOptions());
  }
  public deleteBMProgressMaster(obj: benchmarkprogressmaster) {
    return this.http.post(this.apiURL + '/api/Admin/DeleteBMProgressMaster', obj, this.GetHttpOptions());
  }

  public getDecryptUId(objUser: Users) {
    return this.http.post(this.apiURL + '/api/Login/GetDecryptUId', objUser, this.GetHttpOptions());
  }

 PingLogin() {
    return this.http.post(this.apiURL + '/api/Login/pinglogin', {}, this.GetHttpOptions());
  }

  PingLogout() {
    return this.http.post(this.apiURL + '/api/Login/pinglogout', {}, this.GetHttpOptions());
  }

  SignInOidc(codeObj: RedirectObj) {
    return this.http.post(this.apiURL + '/api/Login/signin-oidc', codeObj, this.GetHttpOptions());
  }

  verifyPingAccessToken(token = '') {
    if(token == '')
      return this.http.post(this.apiURL + '/api/Login/verify-token', { token: localStorage.getItem('musherataccesstoken') }, this.GetHttpOptions());
    else 
      return this.http.post(this.apiURL + '/api/Login/verify-token', { token: token }, this.GetHttpOptions());
  }
}
